<template>
  <div>
    <div class="main">
      <h2>お気に入り店舗</h2>
      <div class="search">
        <div class="fl">
          <a href="javascript:;">全部(4)</a>|
        </div>
        <div class="fr">
          <input type="text" placeholder="キーワード" v-model="val" />
          <img src="../../../assets/img/search2.png" alt />
        </div>
      </div>
      <div class="shop">
        <div class="txt fl">
          <h6>上海迪迈实业有限公司</h6>
          <p>
            備考欄:
            <img src="../../../assets/img/beikao2.png" alt />
          </p>
          <div class="img">
            <img src="../../../assets/img/shangc.png" alt />
            <img src="../../../assets/img/chaxun.png" alt />
            <img src="../../../assets/img/delete.png" alt />
          </div>
        </div>
        <div class="fr lunbo">
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="item in 6" :key="item">
              <h3 class="medium">{{ item }}</h3>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      val: ""
    };
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;
  height: 1000px;
  h2 {
    height: 40px;
    background-color: #eee;
    line-height: 40px;
    padding-left: 20px;
    font-size: 20px;
    span {
      color: #F3C622;
    }
  }
  .search {
    margin-top: 20px;
    margin-bottom: 100px;
    a {
      color: #333;
      padding: 0 20px;
    }
    .fr {
      position: relative;
      margin-right: 30px;
    }
    input {
      width: 100px;
      height: 30px;
    }
    img {
      position: absolute;
      top: 5px;
      right: 5px;
      cursor: pointer;
    }
  }
  .shop {
    height: 120px;
    padding-top: 20px;
    padding-left: 20px;
    border: 1PX solid #ccc;
    .txt {
      h6 {
        font-weight: 700;
        margin-bottom: 5px;
      }
      p {
        font-size: 12px;
        margin-bottom: 20px;
      }
      img {
        vertical-align: middle;
        width: 22px;
        height: 22px;
        margin-left: 12px;
      }
    }
    .lunbo {
      width: 500px;
      height: 100px;
      margin-right: 50px;
      /deep/.el-carousel__container {
        height: 100px;
      }
      /deep/.el-carousel__indicators {
        display: none;
      }
      .el-carousel__item h3 {
        color: #475669;
        font-size: 18px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
  }
}
</style>